import i18n from "i18next";

import langAm from "./locales/language.AM.json";
import langRu from "./locales/language.RU.json";
import langEn from "./locales/language.EN.json";
import HttpService from "./services/HttpService";

const storage = function (newValue = null) {
    const defaultValue = "AM";
    const key = "i18n_lang";

    if (newValue) {
        localStorage.setItem(key, newValue);
    }

    const value = localStorage.getItem(key);
    if (!value) {
        storage(key, defaultValue);
    }

    const result = value || defaultValue;

    HttpService.setDefaultHeader("X-App-Language", result);
    return result;
};

const options = {
    interpolation: {
        escapeValue: false,
    },
    debug: false,// process.env.NODE_ENV !== "production",
    resources: {
        AM: { common: langAm },
        RU: { common: langRu },
        EN: { common: langEn },
    },
    lng: storage(),
    fallbackLng: "AM",
    ns: ["common"],
    defaultNS: "common",
    react: {
        wait: false,
        bindI18n: "languageChanged loaded",
        bindStore: "added removed",
        nsMode: "default",
    },
};

i18n.init(options);
i18n.on("languageChanged", function (lng) {
    storage(lng);
});

export default i18n;